<template>
  <div>
    <md-field md-clearable class="md-toolbar-section-end">
      <md-input placeholder="Search" v-model="search" @input="searchOnTable" />
    </md-field>
    <md-table v-model="searched" :table-header-color="tableHeaderColor">
      <md-table-empty-state
        md-label="No users found"
        :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
      </md-table-empty-state>
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name">{{ item.partial_user.name }}</md-table-cell>
        <md-table-cell md-label="Phone">{{ item.partial_user.phone_number }}</md-table-cell>
        <md-table-cell md-label="Age">{{ item.partial_user.age }}</md-table-cell>
        <md-table-cell md-label="Blood Group">{{ item.blood_group.blood_group }}</md-table-cell>
        <md-table-cell md-label="Gender">{{ item.gender.gender }}</md-table-cell>
        <md-table-cell md-label="Action">
          <button class="buttonEdit" @click="editDonor(item)">
            <span>
              <i class="fa fa-edit"></i>
            </span>
          </button>
          <button class="buttonDelete" @click="deleteitem = true; deleteItemRow = item">
            <span>
              <i class="fa fa-trash"></i>
            </span>
          </button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog :md-active.sync="edit" style="width: auto">
      <md-dialog-title>Edit Donor</md-dialog-title>
      <div class="md-layout" style="width: 70%; margin: 10px auto; height:100%;">
        <md-field>
          <label>Name</label>
          <md-input v-model="name"></md-input>
        </md-field>

        <md-field>
          <label>Phone</label>
          <md-input v-model="phone" maxlength="30" disabled></md-input>
        </md-field>

        <md-field>
          <label style="margin-top: -15px">Date of Birth</label>
          <md-datepicker v-model="age" />
        </md-field>

        <md-field>
          <label>Blood Group</label>

          <md-select v-model="bloodgroupUser">
            <md-option v-for="(blood, operator) in bloodGroup" :key="operator" :value="blood.id">{{blood.blood_group}}</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Gender</label>

          <md-select v-model="genderUser">
            <md-option v-for="(blood, operator) in gender" :key="operator" :value="blood.id">{{blood.gender}}</md-option>
          </md-select>
        </md-field>


      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="edit = false">Close</md-button>
        <md-button class="md-primary" @click="updateDonor">Update</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="deleteitem"  style="width: 50%">
      <md-dialog-title>Delete Donor</md-dialog-title>
      <div style="width: 70%; margin: 10px auto">
        <i class="fa fa-trash" style="margin-left: -5%; font-size: 34px"></i>
        <span style="margin-left: 5%;font-size: 20px">Are you sure?</span>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="deleteitem = false">Close</md-button>
        <md-button class="md-primary" @click="deleteDonor()">Delete</md-button>
      </md-dialog-actions>

    </md-dialog>

  </div>
</template>

<script>
  const toLower = text => {
    return text.toString().toLowerCase()
  }

  const searchByNumber = (items, term) => {
    let newArray = []
    if (term) {
      items = items.filter(item => {
        if(item) {
          toLower(item.partial_user.phone_number).includes(term)
        }
      })
    }
    return items
  }
  var moment = require('moment');
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        search: null,
        searched: [],
        selected: [],
        donorsList: [],
        edit: false,
        name: '',
        phone: '',
        age: null,
        bloodGroup: [],
        gender: [],
        bloodgroupUser: 0,
        genderUser: 0,
        deleteitem: false,
        userEditId: 0,
        curentDonor: '',
        deleteItemRow: ''
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetDonorList').then((response) => {
        this.donorsList = response.data.data;
        console.log('show', response.data.data);
        this.donorsList.forEach((request) => {
          request.partial_user.age = moment().diff(request.partial_user.date_of_birth, 'years');
        })
        this.searched = this.donorsList
      });
      this.$store.dispatch('GetBloodGroup').then((response) => {
        this.bloodGroup = response.data.data;
        console.log('blood',this.bloodGroup)
      });
      this.$store.dispatch('GetGender').then((response) => {
        this.gender = response.data.data;
      })

    },
    methods: {
      searchOnTable () {
        // this.searched = searchByName(this.usersList, this.search)
        this.searched = this.donorsList.filter(item => {
          if(item) {
            if( toLower(item.partial_user.phone_number).includes(this.search) || toLower(item.partial_user.name).includes(this.search) || toLower(item.gender.gender).includes(this.search) || toLower(item.blood_group.blood_group).includes(this.search) || toLower(item.partial_user.age).includes(this.search)){
              return item
            }
          }
        })
        if(this.searched.length<1){
        }
      },
      editDonor(donor) {
        console.log(donor)
        this.curentDonor = donor;
        this.edit = true;
        this.name = donor.partial_user.name;
        this.phone = donor.partial_user.phone_number;
        this.age = donor.partial_user.date_of_birth;
        this.bloodgroupUser = this.bloodGroup.find(bg => bg.id === donor.blood_group.id).id;
        this.genderUser = this.gender.find(gen => gen.id === donor.gender.id).id;

        this.userEditId = donor.partial_user.id;
      },
      deleteDonor(donor) {

      },
      updateDonor() {

        this.curentDonor.blood_group.id = this.bloodgroupUser
        this.curentDonor.partial_user.name = this.name
        this.curentDonor.gender = this.genderUser
        // this.curentDonor.partial_user.date_of_birth = this.donorsList.find(donor => donor.partial_user.id === this.userEditId).partial_user.date_of_birth
        this.curentDonor.partial_user.date_of_birth = moment(this.age).format('YYYY-MM-DD');
        this.$store.dispatch('DonorUpadate', this.curentDonor)
          .then((response) => {
            this.$store.dispatch('DonorProfileInfoUpdate', this.curentDonor)
              .then(response=>{
                this.$store.dispatch('GetDonorList')
                  .then((response) => {
                    this.donorsList = response.data.data;
                    //console.log('update donor', this.donorsList)
                    this.donorsList.forEach((request) => {
                      request.partial_user.age = moment().diff(request.partial_user.date_of_birth, 'years');
                      })
                    this.searched = this.donorsList
                   });
               })

          })
          .catch((error) => {

        })
        this.edit= false
      }
    }
  }
</script>
<style>
  .buttonEdit {
    border-radius: 4px;
    background-color: #0080ff;
    padding: 5px;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px;

  }

  .buttonDelete {
    border-radius: 4px;
    background-color: #f4511e;
    padding: 5px;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
  }

  .md-menu-content{
    z-index: 10 !important;
  }
</style>
